export default function Article2() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <div className="flex gap-4">
              <a 
                href="/blog"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Volver al Blog
              </a>
              <a 
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-home-line mr-2"></i>
                Inicio
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Article Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              Normativas
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-calendar-line"></i>
              <span>10 Enero 2025</span>
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-time-line"></i>
              <span>6 min lectura</span>
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Gas Radón: Protocolo de Medición según RD 1029/2022
          </h1>
          
          <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/02f5057bd3156fb7e381de9015132014.jpg"
              alt="Gas Radón Protocolo de Medición"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Body */}
        <div className="prose prose-lg max-w-none">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-700 font-medium">
              El Real Decreto 1029/2022 establece nuevos requisitos para la protección de la salud contra los riesgos derivados de la exposición al radón. Esta guía detalla el protocolo completo de medición y control.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">¿Qué es el Gas Radón?</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            El radón es un gas radiactivo natural, incoloro e inodoro, que se genera por la desintegración del uranio presente en suelos y rocas. Es la segunda causa de cáncer de pulmón después del tabaco.
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Gas noble radiactivo de origen natural</li>
            <li>Presente en todos los suelos en mayor o menor concentración</li>
            <li>Puede acumularse en espacios cerrados</li>
            <li>Clasificado como carcinógeno de categoría 1 por la OMS</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Marco Normativo RD 1029/2022</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Edificios Afectados</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            La normativa establece obligaciones específicas para:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Lugares de trabajo en planta baja o sótano</li>
            <li>Edificios en zonas de actuación prioritaria</li>
            <li>Instalaciones con trabajadores especialmente expuestos</li>
            <li>Centros educativos y sanitarios en zonas de riesgo</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Niveles de Referencia</h3>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <ul className="text-gray-700 space-y-3">
              <li><strong>300 Bq/m³:</strong> Nivel de referencia para lugares de trabajo</li>
              <li><strong>Medición obligatoria:</strong> En zonas de actuación prioritaria</li>
              <li><strong>Periodicidad:</strong> Cada 10 años o tras reformas significativas</li>
              <li><strong>Duración mínima:</strong> 3 meses de medición continua</li>
            </ul>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Protocolo de Medición</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Planificación de la Medición</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Antes de iniciar la medición, es necesario:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Identificar las zonas a medir (plantas bajas y sótanos)</li>
            <li>Determinar el número de detectores necesarios</li>
            <li>Seleccionar las ubicaciones óptimas para los detectores</li>
            <li>Planificar el periodo de medición (mínimo 3 meses)</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Instalación de Detectores</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Los detectores deben colocarse siguiendo estos criterios:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Altura entre 1 y 2 metros del suelo</li>
            <li>Alejados de corrientes de aire directas</li>
            <li>Separados de paredes y ventanas (mínimo 50 cm)</li>
            <li>En zonas representativas de la ocupación habitual</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Periodo de Medición</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            La medición debe realizarse durante un periodo mínimo de 3 meses, preferiblemente:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Durante los meses de invierno (mayor concentración)</li>
            <li>Con el edificio en condiciones normales de uso</li>
            <li>Manteniendo las condiciones de ventilación habituales</li>
            <li>Registrando cualquier incidencia durante el periodo</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Interpretación de Resultados</h2>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <h4 className="font-semibold text-gray-900 mb-3">Concentración Media Anual</h4>
            <ul className="text-gray-700 space-y-2">
              <li><strong>&lt; 300 Bq/m³:</strong> Nivel aceptable, no se requieren acciones</li>
              <li><strong>300-600 Bq/m³:</strong> Se recomienda implementar medidas correctoras</li>
              <li><strong>&gt; 600 Bq/m³:</strong> Obligatorio implementar medidas correctoras urgentes</li>
            </ul>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Medidas Correctoras</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Si se superan los niveles de referencia, se pueden implementar:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Mejora de la ventilación natural o mecánica</li>
            <li>Sellado de grietas y fisuras en suelos y paredes</li>
            <li>Instalación de sistemas de despresurización del suelo</li>
            <li>Barreras impermeables al radón</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Documentación y Registro</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Es obligatorio mantener un registro que incluya:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Informe técnico de medición</li>
            <li>Planos con ubicación de detectores</li>
            <li>Resultados de las mediciones</li>
            <li>Medidas correctoras implementadas (si procede)</li>
            <li>Verificación de la eficacia de las medidas</li>
          </ul>

          {/* CTA Box */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-8 text-white mt-12">
            <h3 className="text-2xl font-bold mb-4">¿Necesitas medir el gas radón en tu edificio?</h3>
            <p className="mb-6 text-emerald-50">
              Realizamos mediciones oficiales con equipos homologados y emitimos certificados según RD 1029/2022.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/citas"
                className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all text-center whitespace-nowrap"
              >
                Solicitar Medición
              </a>
              <a 
                href="/#contacto"
                className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-all text-center whitespace-nowrap"
              >
                Más Información
              </a>
            </div>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/blog"
            className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Volver al Blog</span>
          </a>
        </div>
      </article>
    </div>
  );
}